import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    // If no user or user role is not admin (1 or 2), redirect to login
    if (!user || (user.userRole !== 1 && user.userRole !== 2)) {
        return <Navigate to="/admin-login" state={{ message: "You must be an admin to access this page" }} />;
    }

    //return user && user.userRole === 1 ? children : <Navigate to="/admin-home" />;
	return children;
};

export default PrivateRoute;
